'use client';

import { createContext, ReactNode, useContext, useRef } from 'react';
import { LogoutAndDisconnectWalletButton, LogoutButton } from './common-buttons';

const LogoutDialogContext = createContext({
  open: (): void => {
    throw new Error('open not implemented');
  },
});

export const LogoutDialogProviderClient = ({
  web3 = false,
  titleText,
  confirmText,
  cancelButtonText,
  logoutButtonText,
  dataTheme,
  children,
}: {
  web3?: boolean;
  titleText: string;
  confirmText: string;
  cancelButtonText: string;
  logoutButtonText: string;
  dataTheme?: string;
  children: ReactNode;
}) => {
  const ref = useRef<HTMLDialogElement>(null);

  return (
    <LogoutDialogContext
      value={{
        open: () => ref.current?.showModal(),
      }}
    >
      <dialog id="logout-dialog" data-theme={dataTheme} ref={ref} className="modal">
        <div className="modal-box text-base-content">
          <h3 className="text-lg font-bold">{titleText}</h3>
          <p className="py-4">{confirmText}</p>
          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-ghost">{cancelButtonText}</button>
            </form>
            <form method="dialog">
              {web3 ? (
                <LogoutAndDisconnectWalletButton fallback={() => ref.current?.close()}>
                  {logoutButtonText}
                </LogoutAndDisconnectWalletButton>
              ) : (
                <LogoutButton fallback={() => ref.current?.close()} className="btn btn-primary">
                  {logoutButtonText}
                </LogoutButton>
              )}
            </form>
          </div>
        </div>
      </dialog>
      {children}
    </LogoutDialogContext>
  );
};

export const useLogoutDialog = () => {
  return useContext(LogoutDialogContext);
};
